import { BillingCardForm } from '@/components/BillingPage/BillingCardForm'
import { Sheet, SheetTitle } from '@/ui/core/sheet'
import { VStack } from '@/ui/core/stack'

/**
 * The web has no native wallet sheet to step into: Stripe's own Elements carry the card fields
 * and the wallet button together, so the sheet holds them in one view.
 */
export const CardSheet = ({
	open,
	onClose,
	onSaved,
}: { open: boolean; onClose: () => void; onSaved: () => void }) => (
	<Sheet open={open} onClose={onClose}>
		<VStack gap={24} className="pt-2 pb-2">
			<SheetTitle glyph="card">Update Card</SheetTitle>
			<BillingCardForm onComplete={onSaved} />
		</VStack>
	</Sheet>
)
